import { render, staticRenderFns } from "./DashboardReservations.vue?vue&type=template&id=bfca03d6&scoped=true&"
import script from "./DashboardReservations.vue?vue&type=script&lang=js&"
export * from "./DashboardReservations.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReservations.vue?vue&type=style&index=0&id=bfca03d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfca03d6",
  null
  
)

export default component.exports